import { render, staticRenderFns } from "./ObjectScndNest.vue?vue&type=template&id=0f067475&scoped=true"
import script from "./ObjectScndNest.vue?vue&type=script&lang=js"
export * from "./ObjectScndNest.vue?vue&type=script&lang=js"
import style0 from "./ObjectScndNest.vue?vue&type=style&index=0&id=0f067475&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f067475",
  null
  
)

export default component.exports